<template>
  <div v-if="categoryList" class="categorySelect">
    <select
      class="input select"
      v-model="selectedId"
      @change="emitChange">
      <option
        v-for="cate in categoryList"
        :key="cate.categoryId"
        :value="cate.categoryId">
        {{ cate.categoryLabel[defaultLang] }}
      </option>
    </select>
    <PageCategory v-if="subCategory"
      :locale="locale"
      :categoryId="categoryId"
      :categoryList="subCategory"
      :categoryListAll="categoryListAll"
      @update="emitChange" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'

export default {
  name: 'PageCategory',
  props: [
    'locale',
    'categoryId',
    'categoryList',
    'categoryListAll'
  ],
  components: {
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    isUnknown () {
      return this.categoryId === 'unknown'
    },
    selectedCategory () {
      return this.categoryList.find(cate => cate.categoryId === this.selectedId)
    },
    subCategory () {
      return this.selectedCategory?.subCategory || null
    }
  },
  watch: {
    categoryId (newCategoryId) {
      this.setSelectedId(newCategoryId)
    }
  },
  created () {
    this.selectedId = this.categoryId || (this.categoryList?.[0]?.categoryId || '')
    this.setSelectedId(this.selectedId)
  },
  data () {
    return {
      selectedId: ''
    }
  },
  methods: {
    setSelectedId (newCategoryId) {
      if (!this.categoryList) return
      // 1) categoryList 내에서 newCategoryId가 포함된 카테고리 찾기
      const findParentOfId = (categories, targetId) => {
        for (const cate of categories) {
          if (cate.categoryId === targetId) {
            // 정확히 자기 자신이면 그대로 리턴
            return cate.categoryId
          }
          if (cate.subCategory) {
            // 하위 서브카테고리 중에 targetId가 있으면, 현재 cate.categoryId를 리턴
            const found = findParentOfId(cate.subCategory, targetId)
            if (found) {
              return cate.categoryId
            }
          }
        }
        return null
      }
      const selected = this.categoryList.find(c => c.categoryId === newCategoryId)
      if (selected) {
        // 현재 리스트 내에 정확히 newCategoryId가 있으면 바로 지정
        this.selectedId = newCategoryId
      } else {
        // newCategoryId가 서브카테고리 안에 있다면 그 자식 카테고리 id로 지정
        const parentId = findParentOfId(this.categoryList, newCategoryId)
        if (parentId) {
          this.selectedId = parentId
        }
      }
    },
    emitChange (selectedId) {
      const categoryId = selectedId?.target?.value || selectedId
      this.$emit('update', categoryId)
    }
  }
}
</script>
